import { Page } from "@/models/page-models/Page";

export const CustomersNew: Page = {
  "path": "customers/new",
  "name": "New Customer",
  "props": {
    "data": {
      "title": "New Customer",
      "printable": "FALSE",
      "url": "customers/new",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.name",
                  "class": "text-caption",
                  "labelType": "formula",
                  "formula": " Fields marked (*) required for Creating a Prospect"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.name",
                  "label": "Customer Name (billing name as per CR)*",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.alias",
                  "label": "Alias*",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nameArabic",
                  "label": "Arabic Name*",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerCategory",
                  "label": "Type",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerTypeByCategory.data.0.data",
                  "itemText": "en",
                  "itemValue": "en"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerTypeBySize",
                  "label": "Size",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerTypeBySize.data.0.data",
                  "itemText": "alias",
                  "itemValue": "en"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerTypeByActivity",
                  "label": "Activity",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerTypeByActivity.data.0.data",
                  "itemText": "en",
                  "itemValue": "en"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerType",
                  "label": "Regular / Miscellaneous",
                  "disabled": "FALSE",
                  "items": "[\"Regular\",\"Miscellaneous\"]",
                  "dropdownType": "static",
                  "showIf": "fn(MATCH_ROLE,General Manager)"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.schemeId",
                  "label": "Customer ID Type (Scheme ID)",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"VAT Number\",\"value\":\"VAT\"},{\"text\":\"Tax Identification Number\",\"value\":\"TIN\"},{\"text\":\"Commercial registration number\",\"value\":\"CRN\"},{\"text\":\"MOMRAH license\",\"value\":\"MOM\"},{\"text\":\"MHRSD license\",\"value\":\"MLS\"},{\"text\":\"700 Number\",\"value\":\"700\"},{\"text\":\"MISA license\",\"value\":\"SAG\"},{\"text\":\"National ID\",\"value\":\"NAT\"},{\"text\":\"GCC ID\",\"value\":\"GCC\"},{\"text\":\"Iqama Number\",\"value\":\"IQA\"},{\"text\":\"Passport ID\",\"value\":\"PAS\"},{\"text\":\"Other ID\",\"value\":\"OTH\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.data.customerType}},'),==,'Miscellaneous')"
                },
                {
                  "type": "input",
                  "variable": "formData.data.identification",
                  "label": "Customer ID #",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.data.customerType}},'),==,'Miscellaneous')"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.data.socialMedia",
                  "label": "Website(s)",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "link",
                          "label": "Link",
                          "disabled": "FALSE"
                        }
                      ]
                    }
                  ]
                },
                {
                  "type": "checkbox",
                  "variable": "formData.data.exportCustomer",
                  "label": "Export Customer",
                  "disabled": "fn(MATCH_ROLE,SALES_ACCOUNT_EXECUTIVE)"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.currency",
                  "label": "Currency",
                  "items": "[\"SAR\",\"USD\"]",
                  "dropdownType": "static",
                  "disabled": "fn(LOGICAL,fn(MATCH_ROLE,SALES_ACCOUNT_EXECUTIVE),||,fn(NOT,{{formData.data.exportCustomer}}))"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Prospect Details"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.data.contactDetails",
          "label": "Contact Details",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "prefix",
                  "label": "Prefix",
                  "disabled": "FALSE",
                  "items": "[\"Mr\",\"Ms\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "firstName",
                  "label": "First Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "lastName",
                  "label": "Last Name",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "position",
                  "label": "Position",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "mobile",
                  "label": "Telephone",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "email",
                  "label": "Email",
                  "disabled": "FALSE"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "mapautocomplete",
                  "variable": "formData.data.address",
                  "label": "Billing Address",
                  "disabled": "FALSE",
                  "hideAliasFields": true
                },
                {
                  "type": "input",
                  "variable": "formData.data.address.alias_en",
                  "label": "Billing Address Alias (en)",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.address}}"
                },
                {
                  "type": "input",
                  "variable": "formData.data.address.alias_ar",
                  "label": "Billing Address Alias (ar)",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.address}}"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.billingContact",
                  "label": "Billing Contact*",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.address}}",
                  "items": "formData.data.contactDetails",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Billing Details"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.data.deliveryAddresses",
          "label": "Delivery Details",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "ref",
                  "label": "Delivery Alias",
                  "disabled": "FALSE"
                },
                {
                  "type": "mapautocomplete",
                  "variable": "location",
                  "label": "Deilvery Location",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "assignedContact",
                  "label": "Assigned Contact",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.contactDetails}}",
                  "items": "formData.data.contactDetails",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.VATNumber",
                  "class": "text-h6",
                  "labelType": "formula",
                  "formula": "VAT"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.VATNumber",
                  "label": "VAT #",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.data.VATProof",
                  "label": "",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.CRNumber",
                  "class": "text-h6",
                  "labelType": "formula",
                  "formula": "CR"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.CRNumber",
                  "label": "CR #",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.data.CRProof",
                  "label": "",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.supplierCode",
                  "label": "Cadis Supplier Code",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.addressCode",
                  "label": "National Address Short Code",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.data.nationalAddressProof",
                  "label": "",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.streetName",
                  "label": "Street Name (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.buildNumber",
                  "label": "Building Number (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.buildNumber",
                  "label": "Building Number (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.streetName",
                  "label": "Street Name (ar)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.additionalNumber",
                  "label": "Additional Number (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.cityName",
                  "label": "City (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.cityName",
                  "label": "City (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.additionalNumber",
                  "label": "Additional Number (ar)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.postalCode",
                  "label": "Postal Code (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.district",
                  "label": "District (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.district",
                  "label": "District (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.postalCode",
                  "label": "Postal Code (ar)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.country",
                  "label": "Country (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.countryCode",
                  "label": "Country Code (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.countryCode",
                  "label": "Country Code (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.country",
                  "label": "Country (ar)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Customer Details"
        },
        {
          "groupItems": [
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.termsAndConditions.tradeTerms.type",
                  "label": "Trade Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "formula": "{{__item.en}} ({{__item.type}})"
                },
                {
                  "type": "input",
                  "variable": "formData.data.termsAndConditions.creditTerms.ceiling",
                  "label": "Credit Ceiling",
                  "unit": "SAR",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.termsAndConditions.paymentTerms.type",
                  "label": "Payment Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.paymentTermOptions.data.0.data",
                  "itemText": "en",
                  "itemValue": "alias",
                  "formula": "{{__item.alias}} ({{__item.en}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(NOT,fn(MATCH_ROLE,Sales | Manager))",
          "label": "Commercial Details"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.assignedTo",
                  "label": "Assign To",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "itemText": "displayName",
                  "itemValue": "_id"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.groups",
                  "label": "Select Groups",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                }
              ],
              "disabled": "fn(NOT,fn(MATCH_ROLE,Sales | Manager))"
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "addCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "label": "Sales Details"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getAssignUsers"
      },
      {
        "executionOrder": 1,
        "name": "getCustomerGroups"
      },
      {
        "executionOrder": 1,
        "name": "getPaymentTerms"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerTypeByCategory",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=customer-type-by-category",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerTypeByCategory"
        },
        "name": "getCustomerTypeByCategory"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerTypeBySize",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=customer-type-by-size",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerTypeBySize"
        },
        "name": "getCustomerTypeBySize"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerTypeByActivity",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=customer-type-by-activity",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerTypeByActivity"
        },
        "name": "getCustomerTypeByActivity"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerFields",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerFields",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.data",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultCustomerFields"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyDefaultTermsAndConditions",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultTermsAndConditions",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.data.termsAndConditions",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultTermsAndConditions"
      }
    ],
    "functions": [
      {
        "name": "getAssignUsers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/businesspartners/assignableUsers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.users"
      },
      {
        "name": "addCustomer",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/businesspartners/addCustomer",
        "arg2Key": "redirectUrl",
        "arg2Value": "/customers",
        "arg3Key": "postData",
        "arg3Value": "formData.data"
      },
      {
        "name": "getCustomerGroups",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/businesspartnergroups",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.customerGroups"
      },
      {
        "name": "getPaymentTerms",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/staticdata?type=payment-terms",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.paymentTermOptions"
      },
      {
        "name": "getDefaultCustomerFields",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "assignedTo": "{{__store.user._id}}",
          "termsAndConditions": "{}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultTermsAndConditions",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "creditTerms": {
            "ceiling": 30000
          },
          "tradeTerms": {
            "type": "CPT"
          },
          "paymentTerms": {
            "type": "Full Prepayment"
          }
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 100
}